/**
 * 表单
 */
import FormItem from '@/marketing_components/layout/create-form/form-item.vue'; // @/components/layout/create-form/form-item.vue
import FormItemV2 from '@/marketing_components/layout/create-form/form-item-v2.vue'; // @/components/layout/create-form/form-item-v2.vue
/**
 * 
 * @param {验证key} formRules 
 * @param {子组件FormItem的props参数key} validateKey 
 */
const mixin = (formRules = 'formRules', validateKey = 'validateKey') => {
    return {
        methods: {
            // 验证
            checkForm() {
                const keys = this.getChildrenValidateKeys();
                const rules = this[formRules];
                let msg = '';
                let errCallback = null;
                for (const item of keys) {
                    const data = _.get(this, item);
                    console.log('data:::::', data, item);
                    const rule = rules[item];
                    const ruleMsg = () => {
                        if (typeof rule.message === 'function') {
                            return rule.message();
                        }
                        return rule.message;
                    };
                    if (!rule) {
                        console.warn(`验证数据空，确认validateKey'${validateKey}正确性`);
                        break;
                    }

                    // 非空
                    if (rule.require && !data) {
                        msg = ruleMsg();
                        errCallback = rule.callback;
                        break;
                    }
                    // 正则
                    if (rule.regExp && !!data) {
                        const regExp = new RegExp(rule.regExp);
                        msg = !regExp.test(data) ? ruleMsg() : '';
                        errCallback = rule.callback;
                        break;
                    }
                    if (rule.validate && !rule.validate(data)) {
                        msg = ruleMsg();
                        errCallback = rule.callback;
                        break;
                    }
                }
                if (typeof errCallback === 'function') {
                    errCallback(msg);
                    return false;
                }
                if (msg) {
                    this.$message(msg);
                    return false;
                }
                return true;
            },
            // 返回子项 验证项
            getChildrenValidateKeys() {
                const keys = this.$children
                    .filter(item => !!item[validateKey])
                    .map(item => item[validateKey]);
                return keys;
            }
        },
        components: {
            FormItem,
            FormItemV2
        }
    };
};
export default mixin;



// WEBPACK FOOTER //
// ./src/mixin/form.js